import { cn } from '@/lib/utils'

/** Single workspace color token for sidebar rows and pip strips. */
export function WorkspaceDot({
  color,
  active = true,
  size = 'md',
  interactive = false,
  staggerIndex = 0,
  className,
  title,
}: {
  color?: string | null
  active?: boolean
  size?: 'sm' | 'md' | 'pip'
  /** Staggered grow + glow when parent has `group/pips` (workspace scope triggers). */
  interactive?: boolean
  staggerIndex?: number
  className?: string
  title?: string
}) {
  const dim = color ?? 'currentColor'
  return (
    <span
      className={cn(
        'shrink-0 rounded-full',
        size === 'pip' &&
          !interactive &&
          cn('block w-[3px] h-[11px]', active ? 'opacity-100' : 'opacity-25'),
        size === 'pip' &&
          interactive &&
          cn(
            'block w-[3px] origin-bottom',
            'h-[11px] transition-[height,width,opacity,box-shadow,transform] duration-300',
            'ease-[cubic-bezier(0.34,1.56,0.64,1)]',
            'group-hover/pips:h-[15px] group-hover/pips:w-[4px]',
            active
              ? 'opacity-100 group-hover/pips:scale-y-105 group-hover/pips:brightness-125'
              : 'opacity-25 group-hover/pips:opacity-75 group-hover/pips:brightness-110',
          ),
        size === 'sm' && cn('h-1.5 w-1.5', active ? 'opacity-100' : 'opacity-25'),
        size === 'md' && cn('h-2 w-2', active ? 'opacity-100' : 'opacity-25'),
        className,
      )}
      style={{
        backgroundColor: dim,
        transitionDelay: interactive ? `${staggerIndex * 48}ms` : undefined,
        boxShadow: active && color ? `0 0 4px 1px ${color}55` : undefined,
      }}
      title={title}
      aria-hidden={!title}
    />
  )
}
